import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import {FormBuilder, FormGroup} from '@angular/forms';
import *  as $ from 'jquery';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-videos-tutoriales',
  templateUrl: './videos-tutoriales.component.html',
  styleUrls: ['./videos-tutoriales.component.scss'],
  animations : fuseAnimations
})
export class VideosTutorialesComponent implements OnInit {
  options: FormGroup;

  colorDimension:string="#789da5";
  textoColorDimension:string="white";
  dimensionStatus:boolean=true;

  textoColorDemographic:string="";
  colorDemographic:string="";
  demographicStatus:boolean=false;

  textoColorLeaders:string="";
  colorLeaders:string="";
  leadersStatus:boolean=false;

  textoColorComment:string="";
  colorComment:string="";
  commentsStatus:boolean=false;

  textoColorExecutive:string="";
  colorExecutive:string="";
  executiveStatus:boolean=false;

  textoColorCorrelations:string="";
  colorCorrelations:string="";
  correlationsStatus:boolean=false;

  barStatus:boolean=true;
  ventana_ancho = $(window).width();

  constructor(
    fb: FormBuilder,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    this.options = fb.group({
      bottom: 0,
      fixed: false,
      top: 0
    });
  }

  ngOnInit() {
    this.detectScreen();
  }

  onResize(event) {
  event.target.innerWidth;
  if(event.target.innerWidth<1280){
  this.barStatus=false;
  }
  else{
  this.barStatus=true;
  }
  }

  detectScreen(){
      if(this.ventana_ancho<1280){
        this.barStatus=false;
      }
      else{
        this.barStatus=true;
      }
    }

  configuracionMenu(posicion:number){
    switch (posicion) {
      case 1:
      this.textoColorDimension="white";
      this.colorDimension="#789da5";
      this.textoColorDemographic="";
      this.colorDemographic="";
      this.textoColorLeaders="";
      this.colorLeaders="";
      this.textoColorComment="";
      this.colorComment="";
      this.textoColorExecutive="";
      this.colorExecutive="";
      this.textoColorCorrelations="";
      this.colorCorrelations="";

      this.dimensionStatus=true;
      this.demographicStatus=false;
      this.leadersStatus=false;
      this.commentsStatus=false;
      this.executiveStatus=false;
      this.correlationsStatus=false;
      break;

      case 2:
      this.textoColorDimension="";
      this.colorDimension="";
      this.textoColorDemographic="white";
      this.colorDemographic="#789da5";
      this.textoColorLeaders="";
      this.colorLeaders="";
      this.textoColorComment="";
      this.colorComment="";
      this.textoColorExecutive="";
      this.colorExecutive="";
      this.textoColorCorrelations="";
      this.colorCorrelations="";

      this.dimensionStatus=false;
      this.demographicStatus=true;
      this.leadersStatus=false;
      this.commentsStatus=false;
      this.executiveStatus=false;
      this.correlationsStatus=false;
      break;

      case 3:
      this.textoColorDimension="";
      this.colorDimension="";
      this.textoColorDemographic="";
      this.colorDemographic="";
      this.textoColorLeaders="white";
      this.colorLeaders="#789da5";
      this.textoColorComment="";
      this.colorComment="";
      this.textoColorExecutive="";
      this.colorExecutive="";
      this.textoColorCorrelations="";
      this.colorCorrelations="";

      this.dimensionStatus=false;
      this.demographicStatus=false;
      this.leadersStatus=true;
      this.commentsStatus=false;
      this.executiveStatus=false;
      this.correlationsStatus=false;
      break;

      case 4:
      this.textoColorDimension="";
      this.colorDimension="";
      this.textoColorDemographic="";
      this.colorDemographic="";
      this.textoColorLeaders="";
      this.colorLeaders="";
      this.textoColorComment="white";
      this.colorComment="#789da5";
      this.textoColorExecutive="";
      this.colorExecutive="";
      this.textoColorCorrelations="";
      this.colorCorrelations="";

      this.dimensionStatus=false;
      this.demographicStatus=false;
      this.leadersStatus=false;
      this.commentsStatus=true;
      this.executiveStatus=false;
      this.correlationsStatus=false;
      break;

      case 5:
      this.textoColorDimension="";
      this.colorDimension="";
      this.textoColorDemographic="";
      this.colorDemographic="";
      this.textoColorLeaders="";
      this.colorLeaders="";
      this.textoColorComment="";
      this.colorComment="";
      this.textoColorExecutive="white";
      this.colorExecutive="#789da5";
      this.textoColorCorrelations="";
      this.colorCorrelations="";

      this.dimensionStatus=false;
      this.demographicStatus=false;
      this.leadersStatus=false;
      this.commentsStatus=false;
      this.executiveStatus=true;
      this.correlationsStatus=false;
      break;

      case 6:
      this.textoColorDimension="";
      this.colorDimension="";
      this.textoColorDemographic="";
      this.colorDemographic="";
      this.textoColorLeaders="";
      this.colorLeaders="";
      this.textoColorComment="";
      this.colorComment="";
      this.textoColorExecutive="";
      this.colorExecutive="";
      this.textoColorCorrelations="white";
      this.colorCorrelations="#789da5";

      this.dimensionStatus=false;
      this.demographicStatus=false;
      this.leadersStatus=false;
      this.commentsStatus=false;
      this.executiveStatus=false;
      this.correlationsStatus=true;
      break;

      default:
        break;
    }
  }

}
